import { useState } from 'react'

import { Alert, Box, Button, Prose } from '@factorialco/deprecated-design-system'
import {
  PerformanceProcessAgreementConclusionsFragment,
  PerformanceProcessAgreementUpdateConclusionsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import i18n from 'modules/core/lib/i18n'

import { ActionInput } from 'modules/performance_process/components/common/ActionInput'

export const AgreementConclusions: React.FC<{
  agreement: PerformanceProcessAgreementConclusionsFragment
}> = ({ agreement }) => {
  const [text, setText] = useState('')
  const [updateConclusions, { loading }] = useMutation(
    PerformanceProcessAgreementUpdateConclusionsDocument,
    {
      variables: {
        agreementId: agreement.id,
        text,
      },
      extractorFn: (data) => data.performanceMutations.updateConclusionsPerformanceAgreement,
    }
  )

  const conclusions = agreement.conclusions?.text ?? ''
  const [editing, setEditing] = useState(false)

  const startEditing = () => {
    setText(conclusions)
    setEditing(true)
  }

  const stopEditing = () => {
    setText(conclusions)
    setEditing(true)
  }

  const handleUpdate = async () => {
    await updateConclusions({})
    setEditing(false)
  }

  return (
    <Box>
      {agreement?._policies?.addConclusions?.can &&
      !agreement.locked &&
      (editing || conclusions === '') ? (
        <ActionInput
          autofocus={editing}
          layout="big"
          onChange={(value) => setText(value)}
          onSubmit={() => handleUpdate()}
          disabled={loading}
          onCancel={() => stopEditing()}
          placeholder={i18n.t('performance_process.agreements.conclusions.add_conclusion')}
          value={text}
        />
      ) : (
        <Box flexDirection="column">
          <Box width="full">
            {!agreement._policies?.addConclusions.can && conclusions === '' ? (
              <Alert color="info">
                {i18n.t('performance_process.agreements.conclusions.empty', {
                  managerName: agreement.managerEvaluation?.reviewerAccess?.fullName,
                })}
              </Alert>
            ) : (
              <Prose markdown>{conclusions}</Prose>
            )}
          </Box>
          {agreement._policies?.addConclusions.can && !agreement.locked && (
            <Box paddingTop="s24" alignItems="flexEnd">
              <Box flexGrow={false}>
                <Button type="secondary" onClick={startEditing} iconName="pencil">
                  {i18n.t('performance_process.agreements.conclusions.edit')}
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      )}
    </Box>
  )
}
